import React from "react";

export const DollarIcon = () => {
  return (
    <svg width={9} height={15} viewBox="0 0 9 15" fill="none">
      <path
        d="M4.5 1v12.833M7.417 3.333H3.042a2.042 2.042 0 100 4.083h2.916a2.042 2.042 0 010 4.084H1"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
